var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app",staticStyle:{"background":"rgba(0,0,0,0)"}},[_c('v-main',[_c('Nav'),_c('router-view'),_c('Footer',{staticClass:"footer"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }